import { AfterViewInit, ChangeDetectorRef, ElementRef, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { DiagramService } from "@app/workflow-common/diagram-view2/services/diagram.service";
import { combineLatest, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { SidepanelModalService } from "@app/sidepanel/services/sidepanel-modal.service";
import { TranslateService } from "@ngx-translate/core";
import { BlockModel, DagSourceModel } from "@app/workflow-common/services/DagSourceModel";
import { AddTaskSidePanelComponent } from "@app/workflow-common/add-task-side-panel/add-task-side-panel.component";
import { TriggerDatasetService } from "@app/workflow-common/services/trigger-dataset.service";
import { WorkflowhttpService } from "@app/workflow-common/services/workflowhttp.service";
import { HistoryTaskStatusModalComponent } from "@app/workflow-common/diagram-view2/panels/history-task-status-modal/history-task-status-modal.component";
var objectNameDisplayContent = {
    'customFields': 'Custom fields'
};
var NodeComponent = /** @class */ (function () {
    function NodeComponent(modalService, changeDetection, _diagramService, _translateService, triggerService, confirmationBoxHelper, ajsScope, _workflowHttp, document) {
        this.modalService = modalService;
        this.changeDetection = changeDetection;
        this._diagramService = _diagramService;
        this._translateService = _translateService;
        this.triggerService = triggerService;
        this.confirmationBoxHelper = confirmationBoxHelper;
        this.ajsScope = ajsScope;
        this._workflowHttp = _workflowHttp;
        this.document = document;
        this.hasParent = false;
        this.direction = 'vertical';
        this.index = undefined;
        this.isNew = false;
        this.isConditional = false;
        this.blockId = '';
        this.model = undefined;
        this.children = [];
        this.condition = undefined;
        this.iconImageUrl = '/images/mx-graph/add.svg';
        this.blockHeaderText = 'What do you want to happen?';
        this.isRoot = false;
        this.modalSubscription = [];
        this._unsubscribeAll = new Subject();
        this.emailBlockDisplay = {
            subject: '',
            toEmailTag: '',
            ccEmailTag: '',
            bccEmailTag: '',
        };
        this.sendJobReportDisplay = {
            templateName: '',
            toEmailTag: '',
        };
        this.setCustomFieldDisplay = {
            templateFieldToGet: '',
            customFieldToSet: ''
        };
        this.smsBlockDisplay = {
            title: '',
            toAddress: '',
        };
        this.notificationBlockDisplay = {
            roles: '',
            message: ''
        };
        this.delayBlockDisplay = {
            interval: '',
            unit: ''
        };
        this.startSequenceBlockDisplay = {
            sequenceName: '',
            sequenceSentTo: ''
        };
        this.setSalesPersonBlockDisplay = {
            AssignTo: ''
        };
        this.sendProposalBlockDisplay = {
            subject: '',
            toEmailTag: '',
            templateName: ''
        };
        this.conditionalDelayBlockDisply = '';
        this.addJobBlockDisply = '';
        this.scheduledActivityBlockDisplay = {
            iconClassNames: {
                'Call': 'fa fa-phone',
                'Email': 'fa fa-envelope',
                'Meeting': 'fas fa-calendar-alt',
                'Task': 'fa fa-list-ul'
            },
            description: '',
            activityType: '',
            activityIcon: '',
            dueDate: '',
            assignTo: '-',
            assigneeIds: [],
        };
        this.subscriptions = [];
        this.deleteMessage = 'This will delete this block and all the following blocks in this workflow.';
        this.onHighlight = '';
        this.highlighDeletableNode = false;
        this.viewMode = 'form';
        this.taskStatus = {};
        this.isAuditHightlight = false;
    }
    NodeComponent.prototype.ngOnInit = function () {
        var _this = this;
        //
        this.isRoot = this.id == 'cs_initializer';
        this.block_name = this.name;
        this.operatorsDisplayText = this.triggerService.getOperatorsDisplayText();
        combineLatest(this._diagramService.diagram$, this._diagramService.markDeletableNodes$)
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function (_a) {
            var nodeParams = _a[0], blockId = _a[1];
            var nodeOptions = nodeParams.nodeOptions;
            _this.nodeOptions = nodeOptions;
            _this.viewMode = _this.nodeOptions.viewMode;
            if (_this.viewMode == 'history' && _this.nodeOptions.tasksStatus && _this.nodeOptions.tasksStatus.hasOwnProperty(_this.blockId)) {
                _this.taskStatus = _this.nodeOptions.tasksStatus[_this.blockId];
            }
            if (_this.viewMode == 'audit') {
                _this.isAuditHightlight = _this.nodeOptions.audit['taskId'].includes(_this.blockId);
            }
            if (blockId == _this.blockId) {
                //this.highlighDeletableNode = true;
            }
        });
        this.formatter();
        this.setTemplate();
        this.setConfirmationModalConfig();
    };
    NodeComponent.prototype.formatter = function () {
        if (this.condition) {
        }
        if (this.name == 'emailBlock') {
            var _a = this.model, subject = _a.subject, toEmailTag = _a.toEmailTag, ccEmailTag = _a.ccEmailTag, bccEmailTag = _a.bccEmailTag;
            this.emailBlockDisplay.subject = subject.replace(/(<([^>]+)>)/gi, "");
            if (Array.isArray(toEmailTag) && toEmailTag.length) {
                var toTagName = toEmailTag.map(function (item) { return item.displayName; });
                this.emailBlockDisplay.toEmailTag = toTagName.join(', ');
            }
            if (Array.isArray(ccEmailTag) && ccEmailTag.length) {
                var ccTagName = ccEmailTag.map(function (item) { return item.displayName; });
                this.emailBlockDisplay.ccEmailTag = ccTagName.join(', ');
            }
            if (Array.isArray(bccEmailTag) && bccEmailTag.length) {
                var bccTagName = bccEmailTag.map(function (item) { return item.displayName; });
                this.emailBlockDisplay.bccEmailTag = bccTagName.join(', ');
            }
        }
        if (this.name == 'smsBlock') {
            var _b = this.model, toSmsTag = _b.toSmsTag, title = _b.title;
            if (Array.isArray(toSmsTag) && toSmsTag.length) {
                var toSmsTagName = toSmsTag.map(function (item) { return item.displayName; });
                this.smsBlockDisplay.toAddress = toSmsTagName.join(', ');
            }
        }
        if (this.name == 'notificationBlock') {
            var _c = this.model, rolesDisplay = _c.rolesDisplay, textMessage = _c.textMessage;
            this.notificationBlockDisplay.roles = rolesDisplay.join(', ');
            this.notificationBlockDisplay.message = textMessage;
        }
        if (this.name == 'scheduledActivityBlock') {
            var _d = this.model, description = _d.description, activityTypeDisplay = _d.activityTypeDisplay, scheduleInterval = _d.scheduleInterval, unit = _d.unit, displayTime = _d.displayTime, assigneeIds = _d.assigneeIds, assigneeDisplay = _d.assigneeDisplay;
            var _unit = scheduleInterval == 1 ? unit.slice(0, -1) : unit;
            var dueDateText = 'Current date +' + scheduleInterval + ' ' + unit + ' at ' + displayTime;
            this.scheduledActivityBlockDisplay.description = description;
            this.scheduledActivityBlockDisplay.activityType = activityTypeDisplay;
            this.scheduledActivityBlockDisplay.activityIcon = this.scheduledActivityBlockDisplay.iconClassNames[activityTypeDisplay];
            this.scheduledActivityBlockDisplay.dueDate = dueDateText;
            this.scheduledActivityBlockDisplay.assignTo = assigneeIds.length > 0 ? assigneeDisplay.join(', ') : '-';
        }
        if (this.name == 'delayBlock') {
            var _e = this.model, interval = _e.interval, unit = _e.unit;
            this.delayBlockDisplay.unit = interval == 1 ? unit.slice(0, -1) : unit;
            this.delayBlockDisplay.interval = interval;
        }
        if (this.name == 'conditionalDelayBlock') {
            var _f = this.model, interval = _f.interval, unit = _f.unit, fieldLabel = _f.fieldLabel, event_method = _f.event_method;
            var conditionalDelayBlockData = this.dagSourceModel.getBlocksSource().getBlockByKey(this.key);
            var displayText = conditionalDelayBlockData['displayText'].join('');
            var _unit = interval == 1 ? unit.slice(0, -1) : unit;
            var _eventName = event_method == 'pass on before' ? 'before' : 'after';
            this.conditionalDelayBlockDisply = displayText
                .replace('#interval#', interval)
                .replace('#unit#', _unit)
                .replace('#eventName#', _eventName)
                .replace('#field#', fieldLabel);
        }
        if (this.name == 'addjobBlock') {
            var displayValue = this.model.displayValue;
            this.addJobBlockDisply = displayValue;
        }
        if (this.name == 'setCustomFieldBlock') {
            this.setCustomFieldDisplay.customFieldToSet = this.model.targetDisplayValue;
            this.setCustomFieldDisplay.templateFieldToGet = this.model.sourceDisplayValue;
        }
        if (this.name == 'sendJobReportBlock') {
            var _g = this.model, templateName = _g.templateName, toEmailTag = _g.toEmailTag;
            if (Array.isArray(toEmailTag) && toEmailTag.length) {
                var toTagName = toEmailTag.map(function (item) { return item.displayName; });
                this.sendJobReportDisplay.toEmailTag = toTagName.join(', ');
            }
            this.sendJobReportDisplay.templateName = templateName;
        }
        if (this.name == 'startSequenceBlock') {
            var _h = this.model, contactId = _h.contactId, templateName = _h.templateName;
            this.startSequenceBlockDisplay.sequenceName = templateName;
            this.startSequenceBlockDisplay.sequenceSentTo = contactId;
        }
        if (this.name == 'setSalesPersonBlock') {
            var displayValue = this.model.displayValue;
            this.setSalesPersonBlockDisplay.AssignTo = displayValue;
        }
        if (this.name == 'sendProposalBlock') {
            var _j = this.model, subject = _j.subject, toEmailTag = _j.toEmailTag, ccEmailTag = _j.ccEmailTag, bccEmailTag = _j.bccEmailTag, templateName = _j.templateName;
            this.sendProposalBlockDisplay.subject = subject.replace(/(<([^>]+)>)/gi, "");
            this.sendProposalBlockDisplay.templateName = templateName;
            if (Array.isArray(toEmailTag) && toEmailTag.length) {
                var toTagName = toEmailTag.map(function (item) { return item.displayName; });
                this.sendProposalBlockDisplay.toEmailTag = toTagName.join(', ');
            }
        }
    };
    NodeComponent.prototype.setConfirmationModalConfig = function () {
        var isDraftMode = this.nodeOptions.isDraftMode;
        var confirmBxValidationMsg = isDraftMode ? this._translateService.instant('confirmation.warning.text', { word: 'ACTIVATE', message: 'activate the automation' }) :
            this._translateService.instant('confirmation.warning.text', { word: 'DEACTIVATE', message: 'deactivate the automation' });
        var actionText = isDraftMode ? 'ACTIVATE' : 'DEACTIVATE';
        var warningTxt = isDraftMode ? 'Confirm.Status.Activation.Message' : 'Confirm.Status.Deactivation.Message.Custom';
        var title = isDraftMode ? 'Confirm.Activation' : 'Confirm.Deactivation';
        var helpTxtList = [];
        if (actionText == 'DEACTIVATE') {
            helpTxtList = ['Custom.Automation.Deactivate.Message'];
        }
        this.statusConfirmationModalConfig = {
            modalType: 'confirm',
            actionText: actionText,
            confirmBtnType: 'DEFAULT',
            confirmBtnText: actionText,
            confirmBxValidationMsg: confirmBxValidationMsg,
            itemText: "Automation",
            showModal: false,
            closeText: 'cancel',
            message: { warningTxt: warningTxt, helpTxtList: helpTxtList },
            title: title,
            doAction: null,
            actionArg: '',
        };
    };
    NodeComponent.prototype.showHistoryTaskStatus = function () {
        var taskId = this.isRoot ? this.id : this.blockId;
        var initialState = {
            task: this.nodeOptions.tasksStatus[taskId],
        };
        var modalRef = this.showHideSidePanel(initialState, HistoryTaskStatusModalComponent);
    };
    NodeComponent.prototype.addNode = function (isEdit) {
        var _this = this;
        if (isEdit === void 0) { isEdit = false; }
        var isDraftMode = this.nodeOptions.isDraftMode;
        if (!isDraftMode && !isEdit) {
            this.showConfirmation('The automation must be disabled before add or insert new action. Do you want to deactivate?')
                .then(function () {
                _this.setConfirmationModalConfig();
                _this.statusConfirmationModalConfig.showModal = true;
                _this.statusConfirmationModalConfig.doAction = _this.deactivateAutomation.bind(_this);
                _this.statusConfirmationModalConfig.actionArg = false;
            }, function () {
                _this.highlighDeletableNode = false;
            });
            return;
        }
        var initialState = {
            title: 'Add action automation',
            objectName: this.nodeOptions.objectName,
            objectNameDisplayText: objectNameDisplayContent[this.nodeOptions.objectName],
            nodeOptions: this.nodeOptions,
            dagSourceModel: this.dagSourceModel,
            workflowType: this.nodeOptions.workflowType,
            blockId: this.isRoot ? 'cs_initializer' : this.blockId,
            actionType: '',
            parentId: this.id,
            isActive: false,
            tableTypeId: 1,
            tableTypeName: '',
            isEdit: isEdit,
            hasChildren: this.children.length > 0,
            screenName: this.screenName,
            isElseBlock: this.name === 'elseBlock',
        };
        var addBlockRef = this.showHideSidePanel(initialState, AddTaskSidePanelComponent);
        addBlockRef.content.onClose.subscribe(function (blockData) {
            var action = blockData.action, data = blockData.data;
            var node = data;
            if (action === 'save_and_close') {
                if (isEdit) {
                    var model = node.model, condition = node.condition;
                    _this.model = model;
                    if (condition) {
                        _this.condition = condition;
                    }
                    _this.dagSourceModel.updateTask(_this.blockId, node);
                    _this.formatter();
                    _this.onHighlight = 'on';
                    _this._diagramService.isNodeUpdated();
                    _this._diagramService.autoSave(true);
                }
                else {
                    if (node.isConditional && !node.hasOwnProperty('id') && _this.children.length == 0) {
                        var _a = node['condition'], col_name = _a.col_name, text = _a.text, type = _a.type, fieldType = _a.fieldType, pageType = _a.pageType;
                        var newElseBlock = new BlockModel({
                            name: 'elseBlock',
                            parentId: _this.id,
                            isConditional: true,
                            model: {},
                            key: '',
                            condition: {
                                operator: 'else',
                                value: '',
                                col_name: col_name,
                                text: text,
                                type: type,
                                fieldType: fieldType,
                                pageType: pageType,
                            }
                        });
                        _this.dagSourceModel.addTask(newElseBlock, _this.id);
                        _this.dagSourceModel.addTask(node, _this.id);
                        _this._diagramService.addNewNode(_this.id, [newElseBlock, node]);
                    }
                    else {
                        if (_this.children.length > 0 && _this.name != 'conditionalBlock') {
                            var downStreamNodes = _this.children;
                            var insertedBlock = _this.dagSourceModel.addTask(node, _this.id);
                            var parentId_1 = insertedBlock.id;
                            // switching parentId while inserting node in between
                            downStreamNodes.forEach(function (_node) {
                                _node.parentId = parentId_1;
                                _this.dagSourceModel.updateTask(_node.blockId, _node);
                            });
                        }
                        else {
                            _this.dagSourceModel.addTask(node, _this.id);
                        }
                        _this._diagramService.addNewNode(_this.id, node);
                    }
                    _this._diagramService.isNodeUpdated();
                    _this._diagramService.autoSave(true);
                }
                addBlockRef.hide();
            }
            else if (action == 'remove_block') {
                var isDraftMode_1 = _this.nodeOptions.isDraftMode;
                if (isDraftMode_1) {
                    _this.highlighDeletableNode = true;
                    var childNodes = _this.dagSourceModel.getAllChildren(_this.blockId);
                    childNodes.forEach(function (_blockId) {
                        _this._diagramService.markDeletableNodes(_blockId);
                    });
                    _this._diagramService.markDeletableNodes(_this.blockId);
                }
                addBlockRef.hide();
                var message = !isDraftMode_1 ? 'The automation must be disabled before deleting this action. Do you want to deactivate?'
                    : 'This will delete this block and all the following blocks in this workflow.';
                var confimartion = _this.showConfirmation(message);
                confimartion.then(function () {
                    if (!isDraftMode_1) {
                        _this.statusConfirmationModalConfig.showModal = true;
                        _this.statusConfirmationModalConfig.doAction = _this.deactivateAutomation.bind(_this);
                        _this.statusConfirmationModalConfig.actionArg = false;
                    }
                    else {
                        _this.statusConfirmationModalConfig.showModal = false;
                        _this.deleteNode();
                        _this._diagramService.isNodeUpdated();
                        _this._diagramService.autoSave(true);
                    }
                }, function () {
                    _this.highlighDeletableNode = false;
                });
            }
        });
    };
    NodeComponent.prototype.showConfirmation = function (message) {
        this.deleteMessage = 'The automation must be deactivate before deleting this action. Do you want to deactivate?';
        var isDraftMode = this.nodeOptions.isDraftMode;
        if (isDraftMode) {
            this.deleteMessage = 'This will delete this block and all the following blocks in this workflow.';
        }
        return this.confirmationBoxHelper.getConfirmation(message, this.ajsScope);
    };
    NodeComponent.prototype.deactivateAutomation = function (deactivate, cb) {
        var _this = this;
        var workflowId = this.nodeOptions.workflowId;
        var automationActivate = {
            workflowId: workflowId,
            status: deactivate
        };
        this._workflowHttp.automationStatusUpdate(workflowId, { automationActivate: automationActivate })
            .subscribe({
            next: function (resp) {
                if (resp.hasOwnProperty('automationActivate')) {
                    cb('SUCCESS');
                    _this.statusConfirmationModalConfig.showModal = false;
                    _this.nodeOptions.isDraftMode = true;
                }
            }
        });
    };
    NodeComponent.prototype.deleteNode = function () {
        this._diagramService.deleteNode(this.parentId, this.index);
        if (this.condition) {
            var childBlocks = this.dagSourceModel.getChildren(this.parentId);
            if (childBlocks.length == 2) {
                this.dagSourceModel.removeTask(childBlocks[0].blockId);
            }
        }
        this.dagSourceModel.removeTask(this.blockId);
    };
    NodeComponent.prototype.editNode = function () {
        if (this.viewMode == 'history') {
            this.showHistoryTaskStatus();
        }
        else if (this.viewMode == 'form') {
            this.addNode(true);
        }
    };
    NodeComponent.prototype.getValue = function (colName, value) {
        var fieldsAsObject = this.dagSourceModel.getFieldMetadata();
        if (!fieldsAsObject[colName]) {
            return '';
        }
        var field = fieldsAsObject[colName];
        if (field.hasOwnProperty('options')) {
            if (Array.isArray(value)) {
                var optionValue = field['options'].filter(function (i) { return value.includes(String(i.id)); });
                var multiVal = optionValue.map(function (t) { return t.text; });
                if (multiVal.length > 0) {
                    value = multiVal.join(', ');
                }
            }
            else {
                var activeOption = field.options.find(function (item) {
                    return item.id == value;
                });
                if (activeOption) {
                    value = activeOption['text'];
                }
            }
        }
        return value;
    };
    NodeComponent.prototype.showHideSidePanel = function (initialState, Component) {
        var _this = this;
        if (initialState === void 0) { initialState = undefined; }
        var _combine = combineLatest(this.modalService.onShow, this.modalService.onHidden)
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function () { return _this.changeDetection.markForCheck(); });
        this.modalSubscription.push(this.modalService.onShow.subscribe(function () {
        }));
        this.modalSubscription.push(this.modalService.onHidden.subscribe(function () {
            _this.unsubscribe();
        }));
        this.modalSubscription.push(_combine);
        return this.modalService.show(Component, {
            initialState: initialState,
            'size': 'md',
            'class': 'workflow-sidepanel'
        });
    };
    NodeComponent.prototype.unsubscribe = function () {
        this.modalSubscription.forEach(function (subscription) {
            subscription.unsubscribe();
        });
    };
    NodeComponent.prototype.ngOnDestroy = function () {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
        this.unsubscribe();
    };
    NodeComponent.prototype.setTemplate = function () {
        var template = this.name + 'Template';
        if (this[template]) {
            this.nodeTemplate = this[template];
        }
        else {
            this.nodeTemplate = this.defaultNodeTemplate;
        }
    };
    NodeComponent.prototype.stripHtml = function (html) {
        var tmp = document.createElement("DIV");
        tmp.innerHTML = html;
        return tmp.textContent || tmp.innerText || "";
    };
    NodeComponent.prototype.ngAfterContentInit = function () {
    };
    NodeComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        if (this.viewMode == 'form') {
            this.onHighlight = 'on';
        }
        this.changeDetection.detectChanges();
        if (this.viewMode == 'audit') {
            if (this.nodeOptions.audit['taskId'][0] == this.blockId) {
                setTimeout(function () {
                    _this._diagramService.setAdjustPositionY(document.getElementById(_this.blockId));
                }, 300);
            }
        }
        this.formatter();
    };
    return NodeComponent;
}());
export { NodeComponent };
